/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalMonthlyGuildMember
 */
export interface GlobalMonthlyGuildMember {
    /**
     * 
     * @type {string}
     * @memberof GlobalMonthlyGuildMember
     */
    guildIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalMonthlyGuildMember
     */
    guildName: string;
    /**
     * 
     * @type {number}
     * @memberof GlobalMonthlyGuildMember
     */
    totalPoints: number;
    /**
     * 
     * @type {string}
     * @memberof GlobalMonthlyGuildMember
     */
    nickname: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalMonthlyGuildMember
     */
    profilePicture?: string;
    /**
     * 
     * @type {number}
     * @memberof GlobalMonthlyGuildMember
     */
    rank: number;
    /**
     * 
     * @type {string}
     * @memberof GlobalMonthlyGuildMember
     */
    id: string;
}

/**
 * Check if a given object implements the GlobalMonthlyGuildMember interface.
 */
export function instanceOfGlobalMonthlyGuildMember(value: object): value is GlobalMonthlyGuildMember {
    if (!('guildName' in value) || value['guildName'] === undefined) return false;
    if (!('totalPoints' in value) || value['totalPoints'] === undefined) return false;
    if (!('nickname' in value) || value['nickname'] === undefined) return false;
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GlobalMonthlyGuildMemberFromJSON(json: any): GlobalMonthlyGuildMember {
    return GlobalMonthlyGuildMemberFromJSONTyped(json, false);
}

export function GlobalMonthlyGuildMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalMonthlyGuildMember {
    if (json == null) {
        return json;
    }
    return {
        
        'guildIcon': json['guildIcon'] == null ? undefined : json['guildIcon'],
        'guildName': json['guildName'],
        'totalPoints': json['totalPoints'],
        'nickname': json['nickname'],
        'profilePicture': json['profilePicture'] == null ? undefined : json['profilePicture'],
        'rank': json['rank'],
        'id': json['id'],
    };
}

export function GlobalMonthlyGuildMemberToJSON(json: any): GlobalMonthlyGuildMember {
    return GlobalMonthlyGuildMemberToJSONTyped(json, false);
}

export function GlobalMonthlyGuildMemberToJSONTyped(value?: GlobalMonthlyGuildMember | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'guildIcon': value['guildIcon'],
        'guildName': value['guildName'],
        'totalPoints': value['totalPoints'],
        'nickname': value['nickname'],
        'profilePicture': value['profilePicture'],
        'rank': value['rank'],
        'id': value['id'],
    };
}

